export function buildCompanyOptionsFromStoreNames(storeNames) {
  const seen = new Map();
  (storeNames || []).forEach((s) => {
    if (s?.company == null || seen.has(s.company)) return;
    seen.set(s.company, {
      id: s.company,
      name: s.company_info?.company_name || s.company_info?.name,
    });
  });
  return Array.from(seen.values());
}
